module.exports = __webpack_public_path__ + "img/header-diamondJewelrySets@2x.b876c91.webp";